const prefix = 'fac';
const iconName = 'drag';
const width = 14;
const height = 16;
const ligatures = [];
const unicode = null;
const svgPathData =
  'M7 15L5.26795 12L8.73205 12L7 15Z M13.75 6H0.25C0.1125 6 0 6.1125 0 6.25V6.75C0 6.8875 0.1125 7 0.25 7H13.75C13.8875 7 14 6.8875 14 6.75V6.25C14 6.1125 13.8875 6 13.75 6ZM13.75 9H0.25C0.1125 9 0 9.1125 0 9.25V9.75C0 9.8875 0.1125 10 0.25 10H13.75C13.8875 10 14 9.8875 14 9.75V9.25C14 9.1125 13.8875 9 13.75 9Z M7 1L8.73205 4H5.26795L7 1Z';

export const faDrag = {
  // Use a prefix like 'fac' that doesn't conflict with a prefix in the standard Font Awesome styles
  // (So avoid fab, fal, fas, far, fa)
  prefix,
  iconName, // Any name you like
  icon: [
    width, // width
    height, // height
    ligatures, // ligatures
    unicode, // unicode (if relevant)
    svgPathData, // svg path data
  ],
};
